import { useMemo } from 'react';
import { NavigateOptions, useLocation, useNavigate } from 'react-router-dom';

export interface NavigationInterface {
  navigate: (to: string | number, options?: NavigateOptions) => void | Promise<void>;
}

export function useNavigation(): NavigationInterface {
  const routerNavigate = useNavigate();
  const { pathname } = useLocation();

  function navigate(to: string | number, options?: NavigateOptions): void | Promise<void> {
    if (typeof to === 'number') return routerNavigate(to);

    const isDrillInNavigation = ['/', '/habits'].includes(pathname) || to.startsWith(`${pathname}/`);
    return routerNavigate(to, { replace: !isDrillInNavigation, ...options });
  }

  return useMemo(() => ({ navigate }), [routerNavigate, pathname]);
}
